import { render, staticRenderFns } from "./CommissionActionApprove.vue?vue&type=template&id=64ac9a3e&"
import script from "./CommissionActionApprove.vue?vue&type=script&lang=ts&"
export * from "./CommissionActionApprove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports